import { render } from "./AntdIcons.vue?vue&type=template&id=6aa5470c"
import script from "./AntdIcons.vue?vue&type=script&lang=js"
export * from "./AntdIcons.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__